import { Injectable, inject } from '@angular/core';
import { App } from '@df/core/app';
import { MultisiteService } from '@df/core/service/multisite';
import { GlobalStorageService } from './global-storage.service';

/**
 * Local storage.
 *
 * @export
 * @class LocalStorage
 * @implements {IWebStorage}
 */
@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends GlobalStorageService {
    private multisiteService = inject(MultisiteService);

    protected override register() {
        this.app.localStorageService = this;
    }
    /**
     * Key getter.
     *
     * @param {string} key
     * @returns {string}
     * @memberof LocalStorage
     */
    public override getKey(key: string): string {
        return 'ngStorage-' + this.multisiteService.base + '-' + key;
    }
}

/**
 * Register service in app
 */
declare module '@df/core/app' {
    interface App {
        localStorageService: LocalStorageService;
    }
}
